import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-inventory-card',
    templateUrl: './inventory-card.component.html',
    styleUrls: ['./inventory-card.component.scss'],
    standalone: false
})
export class InventoryCardComponent implements OnInit {
  @Input() amount!: number;
  @Input() from!: string;
  @Input() isNew!: boolean;
  @Input() received!: string;
  localDateFormat = navigator.language;

  constructor() {}

  ngOnInit(): void {}
}
